import styled from 'styled-components';

export const CarouselSlides = styled.div<{ currentSlide: number }>`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ currentSlide }) => `translateX(-${currentSlide * 100}%)`};
  height: auto;
  will-change: transform;
  backface-visibility: hidden;
  perspective: 1000px;
`;

export const NavButton = styled.button<{ left?: boolean }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  color: grey;
  border: none;
  padding: 1.5rem;
  cursor: pointer;
  opacity: 0;
  font-size: 1rem;
  transition:
    box-shadow 0.2s ease,
    opacity 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ left }) =>
    left
      ? `
        left: 1px;
        border-top-right-radius: 50%;
        border-bottom-right-radius: 50%;
      `
      : `
        right: 1px;
        border-top-left-radius: 50%;
        border-bottom-left-radius: 50%;
      `}

  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 8px rgba(0, 123, 255, 0.6);
  }

  #carousel-container:hover & {
    opacity: 1;
  }

  @media (max-width: 600px) {
    top: 100px;
    translate: 0 0;
  }
`;

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
  border-radius: 8px;

  &:focus-within {
    ${NavButton} {
      opacity: 1;
    }
  }
`;

export const DotsContainer = styled.div`
  width: 94%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;
`;

export const Dot = styled.span<{ active: boolean }>`
  display: inline-block;
  width: 24px;
  height: 24px;
  margin: 0 2px;
  background: ${({ active }) => (active ? '#1114B4' : 'lightblue')};
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.5;
`;

export const CarouselLiveRegion = styled.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  margin: -1px;
  padding: 0;
  border: 0;
`;
